module.exports = __webpack_public_path__ + "img/century_tower.feb2f261.jpg";